import { ElementRef } from '@angular/core';

import { FieldWrapper } from '@ngx-formly/core';
import {
  FocusableMixin,
  FormFocusableService,
} from '@ts/shared/form/focus/util-core';

export abstract class IonFormFieldFocusableWrapperAbstractUiComponent
  extends FieldWrapper
  implements FocusableMixin
{
  abstract scrollHereOnFocus: ElementRef;
  protected abstract formFocusableService: FormFocusableService;

  setFocus(): void {
    const fieldComponent = this.fieldComponent.get(0);

    if (
      fieldComponent &&
      'context' in fieldComponent &&
      this.formFocusableService.isFocusable(fieldComponent.context)
    ) {
      // If field is focusable, relegate to field logic.
      fieldComponent.context.setFocus();
    } else {
      // Otherwise, scroll to the form field container.
      const element = this.scrollHereOnFocus.nativeElement as HTMLElement;
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
